export default "__VITE_ASSET__B5b29sL3__"